<template>
    <div class="address">
        <template v-if="type === 'tracking'">
            <template v-if="orderInfoList.length > 0">
                <div v-for="data in detail.orderInfoList">
                    <div v-for="item in data.orderDetailList" class="address-item van-collapse-item">
                        <i class="icon-send"></i>
                        <i class="icon-yitihuo" v-if="item.isDelivery == 1"></i>
                        <div class="address-item-header__text">
                            <span class="address-concat">
                                {{ item.consignorName }}
                                <span @click.stop>
                                    <a :href="'tel:' + detail.consignorPhone">{{ detail.consignorPhone }}</a>
                                </span>
                            </span>
                            <span class="address-text">{{ item.consignorProvinceName }}{{ item.consigneeCityName }}{{
                                item.consignorDistrictName }}{{ item.consignorAddress }}</span>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <div class="address-item van-collapse-item">
                    <i class="icon-send"></i>
                    <div class="address-item-header__text">
                        <span class="address-concat">
                            {{ detail.consignorName }}
                            <span @click.stop>
                                <a :href="'tel:' + detail.consignorPhone">{{ detail.consignorPhone }}</a>
                            </span>
                        </span>
                        <span class="address-text">{{ detail.consignorAddress }}</span>
                    </div>
                </div>
            </template>
        </template>
        <template v-else>
            <van-collapse v-model="activeName">
                <van-collapse-item v-for="(item, index) in detail.list" :key="item.id">
                    <div slot="title" class="address-item-collapse">
                        <i class="icon-send"></i>
                        <div class="address-item-header__text">
                            <span class="address-concat">
                                {{ item.consignorName }}
                                <span @click.stop v-show="showAddress">
                                    <a :href="'tel:' + item.consignorPhone">{{ item.consignorPhone }}</a>
                                </span>
                                <span v-if="item.status <= 3"
                                    style="color: #042D6F;font-size: 0.32rem;position: absolute;right: 0;">{{
                                        item.statusName }}</span>
                            </span>
                            <span class="address-text" v-show="showAddress">
                                {{ item.consignorProvinceName }}{{ item.consignorCityName }}{{ item.consignorDistrictName }}{{ item.clothingCityName
                                }}{{ item.consignorAddress }}
                            </span>
                        </div>
                    </div>
                    <template v-if="!(detail.acceptType === '1' && detail.pullPackWorkerName === '')">
                        <div class="address-item-collapse__worker line-top line-bottom">
                            <span>拉力君：</span>
                            <span>{{ detail.pullPackWorkerName === "" ? item.pullPackWorkerName : detail.pullPackWorkerName
                            }}</span>
                        </div>
                        <div class="address-item-collapse__concat">
                            <span class="concat-worker" @click="concatWorker"><i
                                    class="icon-concat"></i><span>联系拉力君</span></span>
                            <a class="concat-mobile"
                                :href="'tel:' + (detail.pullPackPhone === '' ? item.pullPackPhone : detail.pullPackPhone)"><i
                                    class="icon-mobile"></i><span>拨打电话</span></a>
                        </div>
                    </template>
                </van-collapse-item>
            </van-collapse>
        </template>
        <div class="address-item">
            <i class="icon-collect"></i>
            <div class="address-item-header__text">
                <span class="address-concat">{{ detail.consigneeName }} <a v-show="showAddress" :href="'tel:' + detail.consigneePhone">{{
                    detail.consigneePhone }}</a></span>
                <span class="address-text" v-show="showAddress">
                    {{ detail.consigneeProvinceName }}{{ detail.consigneeCityName }}{{
                        detail.consigneeDistrictName }}{{ detail.consigneeAddress }}
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import { Toast } from 'vant'

export default {
    name: "AddressItem",
    props: {
        showAddress: {
            type: Boolean,
            default: true
        },
        type: {
            type: String
        },
        detail: {
            type: Object,
            required: true,
        }
    },
    data() {
        return {
            activeName: [],
            orderInfoList: []
        }
    },
    watch: {
        detail: {
            handler(val) {
                this.orderInfoList = val.orderInfoList
            },
            deep: true
        }
    },
    methods: {
        concatWorker() {
            Toast({
                message: '该功能暂未开放',
                duration: 1000
            })
        }
    }
}
</script>

<style lang="scss">
.address {

    .address-item {
        padding: 0.29rem 0.31rem;
        display: flex;
        flex-direction: row;
        align-items: center;
        position: relative;
    }

    .icon-send {
        display: inline-block;
        background: url("../../../assets/send.png") center / 100% no-repeat;
        width: 0.53rem;
        height: 0.53rem;
    }

    .icon-collect {
        display: inline-block;
        background: url("../../../assets/accept.png") center / 100% no-repeat;
        width: 0.53rem;
        height: 0.53rem;
    }

    .address-item-header__text {
        flex: 1;

        a {
            padding-left: 0.3rem;
            font-size: 0.37rem;
            color: #042D6F;
        }
    }

    .address-concat {
        position: relative;
        display: block;
        padding-left: 0.28rem;
        margin-bottom: 0.2rem;
        font-size: 0.37rem;
        color: #4F4F4F;
    }

    .address-text {
        display: block;
        padding-left: 0.28rem;
        line-height: 0.4rem;
        font-size: 0.35rem;
        color: #8F8F8F;
    }

    .address-item-collapse {
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .address-item-collapse__worker {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        height: 0.67rem;
        padding: 0 0.31rem;
        font-size: 0.37rem;
        color: #4F4F4F;
    }

    .address-item-collapse__concat {
        display: flex;
        flex-direction: row;
        align-items: center;
        height: 0.93rem;
        font-size: 0.37rem;
        color: #4F4F4F;

        .concat-worker {
            display: flex;
            flex: 1;
            flex-direction: row;
            justify-content: center;
            border-right: 1px solid #D0D0D0;
        }

        .concat-mobile {
            display: flex;
            flex: 1;
            flex-direction: row;
            justify-content: center;
            font-size: 0.37rem;
            color: #4F4F4F;
        }

        .icon-concat {
            margin-right: 0.31rem;
            transform: translateY(-1px);
            display: inline-block;
            background: url("../../../assets/concat.png") center/100% no-repeat;
            width: 0.53rem;
            height: 0.53rem;
        }

        .icon-mobile {
            margin-right: 0.31rem;
            transform: translateY(-1px);
            display: inline-block;
            background: url("../../../assets/mobile.png") center/100% no-repeat;
            width: 0.39rem;
            height: 0.53rem;
        }
    }
}

.van-cell {
    padding: 0.28rem 0.31rem;
}

.van-collapse-item__content {
    padding: 0;
    background-color: #F5F7F9;
}

.van-collapse-item {
    border-top: 1px solid #E5E5E5;
}

.van-cell .van-icon {
    color: #FE9329;
}

.van-cell:not(:last-child)::after {
    border: none;
}

.icon-yitihuo {
    position: absolute;
    width: .72rem;
    height: .63rem;
    background: url("../../../assets/yitihuo@2x.png") center / 100% no-repeat;
    right: .3rem;
    top: .29rem;
}</style>
